<template>
    <div>
    <v-text-field 
        prepend-icon='mdi-calendar'
        @click:prepend='dialog = true' 
        mask='##-##-####' 
        return-masked-value 
        v-on:focus='setFocus' 
        v-model='date' 
        v-on:blur='handleBlur'
        :label='label'
        :disabled='disabled'
        :rules='dateRules'
        @keydown="change()"
        >
        </v-text-field>
    <v-dialog
        v-model="dialog"
        width="290px"
        >

        <v-date-picker :color="app.color" @change="change()" v-model="picker" scrollable locale="nl-NL">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialog = false">OK</v-btn>
            <v-spacer></v-spacer>
        </v-date-picker>
    </v-dialog>   
</div>

</template>

<script>
import moment, { now } from "moment";
import { mapState } from "vuex";

export default {
  props: {
    field: {
      type: String,
      default: undefined,
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      editing: false,
      rawinput: null,
      dateRules: [
        v => !!v || "Datum is verplicht",
        v => moment(v, "DD-MM-YYYY").isValid() || "Datum is niet geldig",
        v =>
          moment(v, "DD-MM-YYYY").isAfter(moment("1900-01-01", "YYYY-MM-DD")) ||
          "Datum ligt te ver in het verleden"
      ]
    };
  },
  methods: {
    handleBlur() {
      if (this.rawinput != null) {
        this.$store.state.contract[this.field] = moment(
          this.rawinput,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        this.rawinput = null;
      }

      this.editing = false;
    },
    change() {
      this.$store.state.app.contract.hasChange = true;
    },
    setFocus() {
      this.editing = true;
    }
  },
  computed: {
    ...mapState(["app"]),
    date: {
      get() {
        return moment(
          this.$store.state.contract[this.field],
          "YYYY-MM-DD"
        ).format("DD-MM-YYYY");
      },
      set(e) {
        if (this.editing) {
          this.rawinput = e;
        }
      }
    },
    picker: {
      get() {
        if (this.$store.state.contract[this.field] != "") {
          return this.$store.state.contract[this.field];
        } else {
          return null;
        }
      },
      set(e) {
        this.$store.state.contract[this.field] = e;
      }
    }
  }
};
</script>
